import React from "react";
import { motion } from "framer-motion";
import heroImage from "../assets/landing/das3.png";
import { useLanguage } from "../LanguageContext";

const fadeUp = {
  hidden: { opacity: 0, y: 50, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.8, ease: "easeOut" },
  },
};

export default function HeroSection() {
  const { language } = useLanguage();

  return (
    <section
      id="home"
      className="relative flex flex-col lg:flex-row items-center justify-center lg:justify-between
                 py-20 lg:py-32 pt-28 lg:pt-40 min-h-screen lg:min-h-[85vh] overflow-hidden w-screen"
    >
      {/* BACKGROUND LINGKARAN */}
      <div className="absolute inset-0 -z-10 flex items-center justify-center w-full overflow-hidden">
        <div className="absolute rounded-full border-[150px] border-[#F5F5F5]/50 w-[300px] h-[300px] sm:w-[500px] sm:h-[500px]" />
        <div className="absolute rounded-full border-[120px] border-[#F5F5F5]/50 w-[800px] h-[800px] sm:w-[1000px] sm:h-[1000px]" />
        <div className="absolute rounded-full border-[150px] border-[#F5F5F5]/50 w-[1300px] h-[1300px] md:w-[1600px] md:h-[1600px] lg:w-[1900px] lg:h-[1900px]" />
      </div>

      {/* KONTEN */}
      <div className="relative z-10 w-full max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between px-6 sm:px-10">
        {/* TEKS */}
        <motion.div
          className="w-full lg:max-w-xl space-y-3 sm:space-y-5 text-center lg:text-left order-first lg:order-none"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <h1
            className="text-4xl sm:text-6xl lg:text-8xl font-extrabold leading-tight"
            style={{ color: "#1446A5" }}
          >
            In Every <br className="hidden sm:block" /> Connection
          </h1>
          <h2
            className="text-2xl sm:text-4xl lg:text-5xl font-extrabold leading-tight text-[#1446A5]/50"
          >
            a Future Begins
          </h2>
          <p
            className="text-lg sm:text-2xl lg:text-3xl font-semibold leading-loose text-[#366ED8]
                       mx-auto lg:mx-0"
          >
            Empowering Industries <br /> Through Smart IoT Solutions
          </p>
          <motion.button
            onClick={() => {
              const footer = document.getElementById("footer");
              if (footer) footer.scrollIntoView({ behavior: "smooth" });
            }}
            className="mt-4 text-white px-6 py-3 rounded-md font-extrabold hover:opacity-90 transition"
            style={{ backgroundColor: "#1446A5" }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Contact Us
          </motion.button>
        </motion.div>

        {/* GAMBAR */}
        <motion.div
          className="relative w-full lg:w-auto flex justify-center lg:absolute lg:right-0 lg:top-0 z-10 
                     mt-10 lg:mt-0 order-last lg:order-none"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ delay: 0.2 }}
        >
          <img
            src={heroImage}
            alt="Digital Alert System"
            className="drop-shadow-lg w-[280px] sm:w-[350px] lg:w-[500px] max-w-none h-auto"
          />
        </motion.div>
      </div>
    </section>
  );
}
